import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _type_of } from "@swc/helpers/_/_type_of";
var __decorate = this && this.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : _type_of(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable } from "mobx";
var Clock = function Clock() {
    "use strict";
    var _this = this;
    _class_call_check(this, Clock);
    this.diff = 0;
    this.now = function() {
        return Date.now() + _this.diff;
    };
    this.date = function() {
        return new Date(_this.now());
    };
    this.setDay = function(time) {
        var now = new Date(Date.now());
        now.setHours(0, 0, 0, 0);
        time = new Date(time);
        time.setHours(0, 0, 0, 0);
        _this.diff = time.valueOf() - now.valueOf();
    };
    this.reset = function() {
        _this.diff = 0;
    };
};
__decorate([
    observable
], Clock.prototype, "diff", void 0);
export var clock = new Clock();
